import * as React from 'react';
import SVGIcon from '../SVGIcon';

const ListDisplayTypeChoice: React.FC = () => {
  return (
    <SVGIcon width="107" height="56" viewBox="0 0 107 56" fill="none">
      <>
        <g clipPath="url(#clip0_5483_3228)">
          <g clipPath="url(#clip1_5483_3228)">
            <rect width="106.771" height="21" rx="0.536581" fill="#DDDDDD" />
            <rect x="5.33301" y="3.625" width="49.8643" height="4" rx="1" fill="#9A9A9A" />
            <path d="M5.33301 12.3906H14.6488V17.0826H5.33301V12.3906Z" fill="#9A9A9A" />
            <path d="M86.2559 4.10938H102.129V17.1094H86.2559V4.10938Z" fill="#CBCBCB" />
          </g>
          <g clipPath="url(#clip2_5483_3228)">
            <rect y="24" width="106.771" height="21" rx="0.536581" fill="#DDDDDD" />
            <rect x="5.33301" y="27.625" width="49.8643" height="4" rx="1" fill="#9A9A9A" />
            <path d="M5.33301 36.3906H14.6488V41.0826H5.33301V36.3906Z" fill="#9A9A9A" />
            <path d="M86.2559 28.1094H102.129V41.1094H86.2559V28.1094Z" fill="#CBCBCB" />
          </g>
          <g clipPath="url(#clip3_5483_3228)">
            <rect y="48" width="106.771" height="8" rx="0.536581" fill="#DDDDDD" />
            <rect x="5.33301" y="51.625" width="49.8643" height="4" rx="1" fill="#9A9A9A" />
            <path d="M86.2559 52.1094H102.129V65.1094H86.2559V52.1094Z" fill="#CBCBCB" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5483_3228">
            <rect width="107" height="56" fill="white" />
          </clipPath>
          <clipPath id="clip1_5483_3228">
            <rect width="107" height="21" rx="1.66877" fill="white" />
          </clipPath>
          <clipPath id="clip2_5483_3228">
            <rect y="24" width="107" height="21" rx="1.66877" fill="white" />
          </clipPath>
          <clipPath id="clip3_5483_3228">
            <path
              d="M0 49.6688C0 48.7471 0.747132 48 1.66877 48H105.331C106.253 48 107 48.7471 107 49.6688V56H0V49.6688Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </>
    </SVGIcon>
  );
};

export default ListDisplayTypeChoice;
